Vue.component('v2-brand-model-select-box', require('./VueComponents/v2/BrandModelSelectionBar').default);

Vue.component('v2-top-deals', require('./VueComponents/v2/TopDeals').default);
Vue.component('v2-top-deals-entry', require('./VueComponents/v2/TopDealsEntry').default);

Vue.component('v2-catalog-query-box', require('./VueComponents/v2/CatalogQueryCtaBox').default);

Vue.component('v2-compare-graph', require('./VueComponents/v2/CompareGraph').default);

Vue.component('v2-cta-bar', require('./VueComponents/v2/CTABar').default);

// navigation elements
Vue.component('faaren-footer', require('./VueComponents/v2/Navigation/Footer').default);
Vue.component('footer-newsletter-modal', require('./VueComponents/v2/Navigation/NewsletterModal').default);

Vue.component('faaren-navbar', require('./VueComponents/v2/Navigation/NavBar').default);
Vue.component('uvp-modal', require('./VueComponents/v2/Navigation/UVPModal').default);

Vue.component('global-banner', require('./VueComponents/v2/GlobalBanner').default);

// navbar components
Vue.component('grey-button', require('./VueComponents/frontend/components/atoms/buttons/GreyButton').default);
Vue.component('contact-button', require('./VueComponents/frontend/components/atoms/buttons/ContactButton').default);
Vue.component('contact-modal', require('./VueComponents/frontend/components/organisms/ContactModal').default);
Vue.component('seperator-x', require('./VueComponents/frontend/components/organisms/SeperatorX').default);
// pds
// migrated pds elements
Vue.component("google-rating", require("./VueComponents/v2/GoogleRating").default);
Vue.component("customer-reviews", require("./VueComponents/v2/CustomerReviews").default);
Vue.component('buy-box', require('./VueComponents/v2/BuyBox').default);
Vue.component('availability-modal', require('./VueComponents/v2/AvailabilityModal').default);
Vue.component('availability-modal-button', require('./VueComponents/v2/AvailabilityModalButton').default);
Vue.component("checkout-init-form", require("./VueComponents/v2/CheckoutInitForm").default)
Vue.component("ad-delivery-cost-calculator", require("./VueComponents/v2/DeliveryCostCalculator").default);
Vue.component("pds-data-entry", require("./VueComponents/v2/PDSDataEntry").default);
Vue.component("all-features", require("./VueComponents/v2/AllFeatures").default);
Vue.component("top-features", require("./VueComponents/v2/TopFeatures").default);
Vue.component("carousel-lightbox", require("./VueComponents/v2/CarouselLightbox").default)

// legacy pds elements
Vue.component("rating", require("./VueComponents/Helpers/Rating").default)

Vue.component("disturber", require("./VueComponents/v2/Disturber").default)
